export const getLevelsRoot = state => state.levels;
export const getLevels = state => getLevelsRoot(state).levels;


// WEBPACK FOOTER //
// ./src/reducers/levels/selectors.js